import Box from '@mui/material/Box'
import { Button, Divider, Stack, Typography } from '@mui/material'
import { EngineerAvatar } from '../Svgs'
import { AssignDiscipline } from '../../models/Review'
import { useState } from 'react'
import ConfirmReassignComponent from './ConfirmReassignComponent'
import ProgressBarComponent from '../ProgressBarComponent'

interface ManageEngineerProps {
  discipline: AssignDiscipline
}

const ManageEngineerComponent: React.FC<ManageEngineerProps> = ({
  discipline,
}) => {
  const [isConfirmReassignOpen, setIsConfirmReassignOpen] = useState(false)

  return (
    <Stack sx={{ width: '100%', minHeight: '5.8rem' }} gap={'1rem'}>
      <Box display={'flex'} flexDirection={'column'} gap={'5px'}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            boxSizing: 'border-box',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: '10px',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <EngineerAvatar />
            <Typography
              sx={{
                color: '#06004A',
                fontSize: '0.76rem',
                lineHeight: 'normal',
                fontWeight: 500,
              }}
            >
              {discipline.user?.user_name}
            </Typography>
          </Box>
          <Button
            size='small'
            variant='contained'
            disabled
            sx={{
              textTransform: 'none',
              fontSize: '0.64rem',
              borderRadius: '4px',
              height: '1.5rem',
            }}
          >
            email@email.com
          </Button>
        </Box>
      </Box>
      <Box gap='0.5rem' display='flex' alignItems='flex-end'>
        <Box sx={{ display: 'flex', width: '72%' }}>
          <ProgressBarComponent
            completed={89}
            total={100}
            showPercentage={true}
            height='1.5rem'
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: '0.5rem',
            width: '28%',
            justifyContent: 'space-between',
          }}
        >
          <Divider orientation='vertical' flexItem />
          <Button
            variant='outlined'
            onClick={() => setIsConfirmReassignOpen(true)}
            sx={{
              textTransform: 'capitalize',
              fontSize: '0.64rem',
              borderRadius: '4px',
              background: 'transparent',
              border: '1px solid #56003D',
              color: '#56003D',
              height: '1.5rem',
            }}
          >
            Reassign
          </Button>
        </Box>
      </Box>
      <ConfirmReassignComponent
        isOpen={isConfirmReassignOpen}
        discipline={discipline}
        handleSubmit={() => {} /*onReassign(discipline.id)*/}
        handleClose={() => setIsConfirmReassignOpen(false)}
      />
    </Stack>
  )
}

export default ManageEngineerComponent
